function fuzzySearch(needle, haystack) {
    const needleWords = needle.toLowerCase().split(" ");
    const haystackWithSpace = " " + haystack.toLowerCase();
    for(let n in needleWords) {
        if (haystackWithSpace.indexOf(" " + needleWords[n]) === -1) {
            return false;
        }
    }
    return true;
}

export default fuzzySearch;



// WEBPACK FOOTER //
// ./assets/js/fuzzy-search.js